"use client";

import { Capacitor, registerPlugin } from "@capacitor/core";

export type HiiveSplashPlugin = {
  /** Releases the Android system splash once the web app has laid out content. */
  ready(): Promise<void>;
};

const HiiveSplash = registerPlugin<HiiveSplashPlugin>("HiiveSplash");

/**
 * Tells the native shell the web app has painted real content so it can dismiss
 * the splash. iOS listens on a WKScriptMessage handler (HiiveBridgeViewController);
 * Android exposes the HiiveSplash plugin (MainActivity). Both sides also run a
 * safety timeout, so a failure here only means the splash holds a little longer.
 */
export async function signalNativeSplashReady(): Promise<void> {
  if (Capacitor.getPlatform() !== "android") return;
  try {
    await HiiveSplash.ready();
  } catch {
    // Older shells without the plugin fall back to the native safety timeout.
  }
}
